import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

import { PageBack } from "@/modules/irohana-components/elements/PageBack";
import { Tag } from "@/modules/irohana-components/elements/Tag";
import { button, text } from "@/modules/irohana-components/theme/colors";
import { TRequiredOne } from "@/modules/irohana-components/types/common";

export type TTopPageProps = {
  title: string;
  subTitle?: ReactNode;
  description?: string;
  rightContent?: ReactNode;
  isDraft?: boolean;
  tooltip?: ReactNode;
  gap?: number;
  descriptionSx?: SxProps<Theme>;
} & TRequiredOne<{ backUrl: string; enablePageBack: boolean; onBack?: () => void }>;

export const TopPage: FC<TTopPageProps> = ({
  title,
  subTitle,
  description,
  backUrl,
  enablePageBack = true,
  onBack,
  rightContent,
  isDraft,
  tooltip,
  gap,
  descriptionSx,
}) => {
  return (
    <Stack gap={gap ?? 3} pb={3}>
      {enablePageBack && <PageBack backUrl={backUrl} onBack={onBack} />}
      <Stack direction="row" gap={3} alignItems="center">
        <Stack gap={1} flex={1}>
          <Stack gap={0.5}>
            {subTitle && <Typography variant="body14">{subTitle}</Typography>}
            <Stack flexDirection="row" alignItems="center" gap={2}>
              <Typography variant="head24Bold">{title}</Typography>
              {isDraft && <Tag title="下書き" variant="bold" color={button.secondary} textColor={text.white} />}
              {tooltip}
            </Stack>
          </Stack>
          {description && (
            <Typography sx={{ whiteSpace: "pre-line", ...descriptionSx }} variant="body14" component="p" mt={2}>
              {description}
            </Typography>
          )}
        </Stack>
        {rightContent}
      </Stack>
    </Stack>
  );
};
